<template>
  <section v-if="nodes" class="section">
    <div class="container">
      <div class="mb-section-y">
        <h2 class="title is-h3">
          {{ $texts('relatedNodes', 'You Might Also Like') }}
        </h2>
      </div>
      <div class="teaser-grid is-TeaserQuarter is-scrollable-mobile">
        <div class="teaser-grid-inner">
          <div v-for="node in nodes" :key="node.id" class="relative">
            <TeaserQuarter
              v-if="node"
              :title="node.teaserTitle"
              :url="node.url?.path"
              :tagline="getTagline(node)"
              :media="node.teaserImage"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
import type { TeaserNodeFragment } from '#graphql-operations'
import { filterNullArray } from '~/helpers'

const { $texts } = useEasyTexts()

const props = defineProps<{
  nid: string
}>()

const language = useCurrentLanguage()

const { data: nodes } = await useAsyncGraphqlQuery(
  'relatedNodes',
  {
    id: props.nid?.toString(),
  },
  {
    transform: (data) => {
      const node = data.data.node
      if (node && 'related' in node && node.related) {
        return filterNullArray(node.related)
      }

      return []
    },
    watch: [language],
  },
)

function getTagline(node: TeaserNodeFragment) {
  /* Old code:
 getTagline(node: any) {
   return node.teaserTagline || node.logoTheme?.top || ''
 }
 */
  return node.teaserTagline || node.logoTheme?.top || ''
}
</script>
